var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('button',_vm._g(_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"scroll-to-top",on:{"click":_vm.scrollToTop}},'button',attrs,false),on),[_vm._t("default",[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" mdi-arrow-up ")])])],2)]}}],null,true)},[_c('span',[_vm._v("Voltar ao Topo")])])}
var staticRenderFns = []

export { render, staticRenderFns }